module.exports = __webpack_public_path__ + "static/img/smile.01de36ce.png";